export default "/staticreactui/static/media/static/media/customer4.e7e57e56.webp";